import { atom } from "recoil";

export const clinicalHistoryState = atom({
    key: 'clinicalHistoryState',
    default: [],
});